import { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCities } from '../redux/actions/city';
import { getCompanies, getCompanyById } from '../redux/actions/company';
import { getStates } from '../redux/actions/state';
import { getCountries } from '../redux/actions/country';
import { useUser } from './UserContext';
import { userGlobalSettings } from '../redux/actions/settings';

const GlobalContext = createContext({
   cityList: [],
   stateList: [],
   countryList: [],
   companyList: [],
   userGlobalSettings: [],
});

export const useGlobal = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
   const { user } = useUser();
   const cityList = useSelector((state) => state.city.list);
   const stateList = useSelector((state) => state.state.list);
   const countryList = useSelector((state) => state.country.list);
   const companyList = useSelector((state) => state.company.list);
   const company = companyList.find((comp) => comp.id === user?.loginhistory?.companyId);
   const userGlobalSettingsData = useSelector((state) => state?.users?.globalSettings);
   const dispatch = useDispatch();

   useEffect(() => {
      dispatch(getCities());
      dispatch(getStates());
      dispatch(getCountries());
      dispatch(getCompanies());
      dispatch(userGlobalSettings());
   }, [dispatch]);

   // useEffect(() => {
   //    if (user && user?.loginhistory?.companyId) {
   //       dispatch(getCompanyById(user?.loginhistory?.companyId));
   //    }
   // }, [dispatch, user]);

   return (
      <GlobalContext.Provider
         value={{ cityList, stateList, countryList, companyList, company, userGlobalSettingsData }}>
         {children}
      </GlobalContext.Provider>
   );
};
